/*
 * Copyright (c) 2000-2022 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

/**
 * A function that can be called as an asynchronous one with the `await` keyword that waits for the
 * the specified amount of milliseconds.
 *
 * @param durationMs  the number of milliseconds to wait (before resolving the returned promise)
 * @return  a `Promise` instance that is resolved after the specified amount of milliseconds elapses
 */
export function delay(durationMs: number): Promise<void> {
  return new Promise((
      resolve: () => void
  ) => {
    setTimeout(() => {
      resolve();
    }, durationMs);
  });
}
